module.exports = __webpack_public_path__ + "img/question-deco-mb.76c8f68.svg";